import React from 'react';
import { ArrowRight } from 'lucide-react';
import { shareNative } from '../lib/share';

const ShareCriticalThinking = () => {
  const handleInvite = () => {
    shareNative({
      title: 'BWGELA - Free Critical Thinking Tools',
      text: "I have been using BWGELA and thought you might like it. It is a free platform for critical thinking, bias awareness and authentic expression, with numerous tools and resources.",
      url: window.location.href,
    });
  };

  return (
    <div className="w-full px-4 mt-4 mb-16">
      <div className="max-w-xl mx-auto">
        <button
          onClick={handleInvite}
          className="w-full bg-[#1a1a1a] hover:bg-[#252525] border border-[#333] rounded-2xl p-8 transition-all duration-300 group"
          data-testid="invite-friends-btn"
        >
          <div className="flex items-center justify-center gap-2 mb-3">
            <h3 className="text-xl text-[#F5F5DC] group-hover:text-white transition-colors">
              Invite Friends
            </h3>
            <ArrowRight className="h-5 w-5 text-[#F5F5DC] group-hover:text-white group-hover:translate-x-1 transition-all" />
          </div>
          <p className="text-white text-base">
            Share the journey with a friend who values critical thinking and truth
          </p>
        </button>
      </div>
    </div>
  );
};

export default ShareCriticalThinking;
